export default __webpack_public_path__ + "static/media/mug.94e95da8.jpg";